











































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePpiIsk } from "@/store/modules/PpiIskStore";
import { appModule } from "@/store/modules/app";
import PpiIskSvc from "@/services/PpiIskService";
import BundleItemTriState from "@/components/pemeriksaan/bundle-ppi/BundleItemTriState.vue";
import BundleObservasiList from "@/components/pemeriksaan/bundle-ppi/BundleObservasiList.vue";
import {
  labelObservasi,
  nowHm,
  todayIso,
  trimJam,
  trimTanggal
} from "@/utils/bundlePpiObservasi";

@Component({
  components: { BundleItemTriState, BundleObservasiList }
})
export default class PpiIskPage extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) isActive!: boolean;

  get readOnly(): boolean {
    return false;
  }

  form: any = this.defaultForm();
  saving = false;
  deleteDialog = false;
  deleting = false;
  loaded = false;
  rowToDelete: any = null;
  showForm = false;

  /** null = item belum/tidak dinilai (tidak masuk denominator kepatuhan). */
  defaultForm() {
    return {
      tanggal_observasi: todayIso(),
      jam_observasi: nowHm(),
      ins_sesuai_indikasi: null,
      ins_hand_hygiene: null,
      ins_teknik_aseptik: null,
      ins_apd_steril: null,
      ins_fiksasi_paha: null,
      ins_petugas_terlatih: null,
      mnt_hand_hygiene: null,
      mnt_drainase_tertutup: null,
      mnt_bag_rendah_bladder: null,
      mnt_periuretra_2x_hari: null,
      mnt_spesimen_aseptik: null,
      mnt_evaluasi_harian: null,
      mnt_manipulasi_aseptik: null,
      mnt_urinal_individual: null,
    };
  }

  get ppiIsk() { return storePpiIsk.currentItem; }
  get list() { return storePpiIsk.list; }
  get loading() { return storePpiIsk.loading; }

  get judulForm(): string {
    return this.ppiIsk && this.ppiIsk.id
      ? "Ubah Observasi — " + labelObservasi(this.ppiIsk)
      : "Observasi Baru";
  }

  /** Persen dihitung atas item yang DINILAI saja (kepatuhan_total dari server). */
  get kepatuhanPersen() {
    if (!this.ppiIsk) return 0;
    const total = this.ppiIsk.kepatuhan_total || 0;
    if (!total) return 0;
    const count = this.ppiIsk.kepatuhan_count || 0;
    return Math.round((count / total) * 1000) / 10;
  }

  get kepatuhanColor() {
    const persen = this.kepatuhanPersen;
    if (persen >= 80) return "success";
    if (persen >= 50) return "warning";
    return "error";
  }

  @Watch("isActive", { immediate: true })
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.fetchData();
      this.loaded = true;
    }
  }

  @Watch("ppiIsk", { immediate: true })
  onDataChange() {
    if (this.ppiIsk) this.populateForm();
    else this.form = this.defaultForm();
  }

  async fetchData() {
    await storePpiIsk.getByRegister(this.register);
  }

  /** null dari server = "tidak dinilai" — harus ikut tersalin, jangan di-skip. */
  populateForm() {
    const d = this.ppiIsk;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined) this.form[key] = d[key];
    });
    this.form.tanggal_observasi = trimTanggal(d.tanggal_observasi) || todayIso();
    this.form.jam_observasi = trimJam(d.jam_observasi);
  }

  labelObservasi(row: any): string { return labelObservasi(row); }

  tambahObservasi() {
    storePpiIsk.select(null);
    this.showForm = true;
  }

  pilihObservasi(row: any) {
    storePpiIsk.select(row);
    this.showForm = true;
  }

  tutupForm() {
    storePpiIsk.select(null);
    this.showForm = false;
  }

  cetakObservasi(row: any) { PpiIskSvc.printPdf(row.id); }

  async save() {
    if (!this.form.tanggal_observasi) {
      appModule.NoticeDelay("Tanggal Observasi harus diisi");
      return;
    }
    this.saving = true;
    try {
      let resp;
      if (this.ppiIsk?.id) {
        resp = await PpiIskSvc.update(this.ppiIsk.id, { ...this.form, register_id: this.register, pasien_rm: this.rm });
      } else {
        resp = await PpiIskSvc.create({ ...this.form, register_id: this.register, pasien_rm: this.rm });
      }
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menyimpan Bundle ISK");
        await storePpiIsk.getByRegister(this.register);
        if (resp.data.data?.id) await storePpiIsk.refresh(resp.data.data.id);
      }
    } catch (e) { /* handled by service */ }
    this.saving = false;
  }

  confirmDelete(row: any) {
    this.rowToDelete = row || this.ppiIsk;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.rowToDelete?.id) {
      this.deleteDialog = false;
      return;
    }
    const terpilih = this.ppiIsk && this.ppiIsk.id === this.rowToDelete.id;
    this.deleting = true;
    try {
      const resp = await PpiIskSvc.destroy(this.rowToDelete.id);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menghapus observasi Bundle ISK");
        if (terpilih) this.tutupForm();
        await storePpiIsk.getByRegister(this.register);
        this.deleteDialog = false;
        this.rowToDelete = null;
      }
    } catch (e) { /* handled by service */ }
    this.deleting = false;
  }

  beforeDestroy() { storePpiIsk.reset(); }
}
